// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"99a7c3e5","318":"ea5b79a9","653":"f8c7b263"}[chunkId] + ".chunk.css";
};